export const USER_EMAIL_TOKEN = 'userEmailToken' as const;
